import React, { useState } from 'react';
import { 
  BugReport
} from '@mui/icons-material';
import Grid from '@mui/material/Grid2';

import { UserTicket } from "@models";
import { TicketType } from "@dndModels/Types";

import DandDAPI from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CenteredMenu from "@components/input/menus/CenteredMenu";
import StringBox from "@components/input/strings/StringBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
import ToastBox from "@components/display/ToastBox";

const api = DandDAPI.getInstance();
const common_util = CommonUtilities.getInstance();

export default function BugButton() {
  const [open, setOpen] = useState(false);
  const [view, setView] = useState("Report Bug");
  const [subject, setSubject] = useState("");
  const [text, setText] = useState("");
  const [processing, setProcessing] = useState(false);
  const [toast_time, setToastTime] = useState(-1);
  const [msg, setMsg] = useState("");

  const submit = async () => {
    if (api.user) {
      setProcessing(true);
      const user_ticket = new UserTicket();
      user_ticket.ticket_type = view === "Report Bug" ? "Bug" : view as TicketType;
      user_ticket.subject = subject;
      user_ticket.text = text;
      user_ticket.owner_id = api.user._id;
      user_ticket.owner = api.user;
      const res = await api.upsertObject("user_ticket", user_ticket);
      if (res && res.body.id) {
        setMsg("Ticket Added");
      } else {
        debugger;
        setMsg("Ticket Add Error");
      }
      setToastTime(common_util.get_time_number());
      setProcessing(false);
      setOpen(false);
    }
  }

  const cancel = () => {
    setView("Report Bug");
    setSubject("");
    setText("");
    setOpen(false);
  }

  const renderExtras = () => {
    return (
      <>
        <ModalOrDrawer
          open={open}
          onClose={cancel}>
          <Grid container spacing={0} direction="row">
            <Grid
              size={{
                xs: 12
              }}>
              <CenteredMenu
                options={["Report Bug", "Suggestion", "Comment"]}
                selected={view}
                onSelect={(changed: string) => { setView(changed); }}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <StringBox
                name="Subject"
                value={subject}
                onBlur={setSubject}
              />
            </Grid>
            <Grid
              size={{
                xs: 12
              }}>
              <StringBox
                name=""
                value={text}
                multiline
                onBlur={setText}
              />
            </Grid>
            <Grid
              size={{
                xs: 6
              }}>
              <ButtonBox
                name="Submit" 
                className="padded"
                disabled={processing}
                onClick={submit}
              />
            </Grid>
            <Grid
              size={{
                xs: 6
              }}>
              <ButtonBox
                name="Cancel" 
                className="padded"
                disabled={processing}
                onClick={cancel}
              />
            </Grid>
          </Grid>
        </ModalOrDrawer>
        <ToastBox
          openTime={ toast_time }
        >
          { msg }
        </ToastBox>
      </>
    );
  }

  return (
    <div>
      <BugReport className="clickable" style={{ padding: "11px" }} onClick={() => { setOpen(true); }} />
      { renderExtras() }
    </div>
  );
}
